/** A global list to keep track of large or negative zIndex values */
const GlobalZIndex = {
    GradientBar: -1,
    ShadowImage: -1,
    Tooltip: 100,
    Overlay: 9002,
    ViewPanelResizeTarget: 1000,
    DatePicker: 9001,
    ShadeShadow: 99999998,
    ShadeContent: 99999999,
};

export { GlobalZIndex };
